import React from 'react';
import { Search, Filter, Download, ArrowUpRight } from 'lucide-react';
const mockPayments = [{
  id: 'TX-9928',
  date: 'Jun 14, 2026',
  consumer: 'Lissette Berpan',
  amount: 707.36,
  type: 'Payment Plan',
  method: 'ACH',
  status: 'Completed',
  ref: 'REF-284910'
}, {
  id: 'TX-9927',
  date: 'Jun 14, 2026',
  consumer: 'Michael Chang',
  amount: 150.0,
  type: 'Pay in Full',
  method: 'Card',
  status: 'Completed',
  ref: 'REF-284909'
}, {
  id: 'TX-9926',
  date: 'Jun 13, 2026',
  consumer: 'David Smith',
  amount: 2500.0,
  type: 'Settlement',
  method: 'ACH',
  status: 'Pending',
  ref: 'REF-284908'
}, {
  id: 'TX-9925',
  date: 'Jun 13, 2026',
  consumer: 'Amanda Cole',
  amount: 50.0,
  type: 'Payment Plan',
  method: 'Card',
  status: 'Failed',
  ref: 'REF-284907'
}, {
  id: 'TX-9924',
  date: 'Jun 12, 2026',
  consumer: 'Robert Fox',
  amount: 420.0,
  type: 'Pay in Full',
  method: 'ACH',
  status: 'Completed',
  ref: 'REF-284906'
}];
export function Payments() {
  return <div className="p-8 max-w-[1600px] mx-auto flex flex-col h-full" data-id="element-1380">
      <div className="flex items-center justify-between mb-6 shrink-0" data-id="element-1381">
        <h1 className="text-2xl font-bold text-brand-navy" data-id="element-1382">Payments</h1>
        <button className="flex items-center gap-2 bg-white border border-gray-200 hover:bg-gray-50 text-brand-navy px-4 py-2 rounded-lg text-sm font-bold transition-colors shadow-sm" data-id="element-1383">
          <Download size={16} data-id="element-1384" />
          Export CSV
        </button>
      </div>

      {/* Summary Bar */}
      <div className="bg-brand-navy text-white rounded-xl p-4 mb-6 flex items-center justify-between shrink-0 shadow-sm" data-id="element-1385">
        <div className="flex items-center gap-8" data-id="element-1386">
          <div data-id="element-1387">
            <p className="text-xs text-blue-200 font-medium uppercase tracking-wider mb-1" data-id="element-1388">
              Total Volume
            </p>
            <p className="text-xl font-bold" data-id="element-1389">$124,500.00</p>
          </div>
          <div className="w-px h-8 bg-blue-800" data-id="element-1390"></div>
          <div data-id="element-1391">
            <p className="text-xs text-blue-200 font-medium uppercase tracking-wider mb-1" data-id="element-1392">
              Pending
            </p>
            <p className="text-xl font-bold" data-id="element-1393">$3,200.00</p>
          </div>
          <div className="w-px h-8 bg-blue-800" data-id="element-1394"></div>
          <div data-id="element-1395">
            <p className="text-xs text-blue-200 font-medium uppercase tracking-wider mb-1" data-id="element-1396">
              Transactions
            </p>
            <p className="text-xl font-bold" data-id="element-1397">284</p>
          </div>
        </div>
      </div>

      {/* Filters Bar */}
      <div className="flex items-center gap-4 mb-6 shrink-0" data-id="element-1398">
        <div className="relative flex-1 max-w-md" data-id="element-1399">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1400" />
          <input type="text" placeholder="Search by consumer or ref #..." className="w-full pl-9 pr-4 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-navy" data-id="element-1401" />
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-1402">
          <Filter size={16} data-id="element-1403" />
          Date Range
        </button>
        <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-1404">
          <Filter size={16} data-id="element-1405" />
          Payment Type
        </button>
        <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-1406">
          <Filter size={16} data-id="element-1407" />
          Status
        </button>
      </div>

      {/* Table */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex-1 flex flex-col" data-id="element-1408">
        <div className="overflow-x-auto flex-1" data-id="element-1409">
          <table className="w-full text-left border-collapse" data-id="element-1410">
            <thead data-id="element-1411">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1412">
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1413">
                  Date
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1414">
                  Consumer
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1415">
                  Amount
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1416">
                  Type
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1417">
                  Method
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1418">
                  Status
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1419">
                  Ref #
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider text-right" data-id="element-1420"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1421">
              {mockPayments.map(p => <tr key={p.id} className="hover:bg-gray-50 cursor-pointer transition-colors group" data-id="element-1422">
                  <td className="px-6 py-4 text-sm text-gray-500" data-id="element-1423">{p.date}</td>
                  <td className="px-6 py-4 text-sm font-bold text-brand-navy" data-id="element-1424">
                    {p.consumer}
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-brand-dark" data-id="element-1425">
                    $
                    {p.amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-1426">{p.type}</td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-1427">
                    {p.method}
                  </td>
                  <td className="px-6 py-4" data-id="element-1428">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-bold border ${p.status === 'Completed' ? 'bg-green-50 text-green-700 border-green-200' : p.status === 'Pending' ? 'bg-amber-50 text-amber-700 border-amber-200' : 'bg-red-50 text-red-700 border-red-200'}`} data-id="element-1429">
                      {p.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500 font-mono" data-id="element-1430">
                    {p.ref}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-1431">
                    <button className="text-gray-400 hover:text-brand-navy p-1 rounded transition-colors opacity-0 group-hover:opacity-100" data-id="element-1432">
                      <ArrowUpRight size={18} data-id="element-1433" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}